import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_ModelCard = _resolveComponent("ModelCard")!
  const _component_ConfigCardOverlay = _resolveComponent("ConfigCardOverlay")!

  return (_openBlock(), _createBlock(_component_ConfigCardOverlay, {
    "model-value": _ctx.modelValue,
    title: "Add a new model",
    "onUpdate:modelValue": _ctx.onToggle,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onToggle(false)))
  }, {
    default: _withCtx(() => [
      (!_ctx.connected.size)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "info",
            variant: "tonal",
            density: "comfortable",
            icon: "mdi-power-plug-outline",
            class: "mb-0"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Connect a provider on the "),
              _createElementVNode("strong", null, "Providers", -1),
              _createTextVNode(" tab first, then add a model here. ")
            ])),
            _: 1,
            __: [2]
          }))
        : (_ctx.modelValue)
          ? (_openBlock(), _createBlock(_component_ModelCard, {
              key: 1,
              isOverlay: "",
              onSaved: _ctx.onSaved,
              onRemoveCard: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onToggle(false)))
            }, null, 8, ["onSaved"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}